import React,{useState,useEffect} from 'react';
import {TableDatePicker,btnSetColorSerlized_CBack,
    btnSetColorDirect_CBack,getWaUrlPath} from '../function_lib/common_lib';
import {FileUploaderV1} from '../function_lib/upload_lib_file';
import  {Multi_Member_Edit_Form} from './multi_member_edit_form';


import './comp_form_digital_seva_new.css';
export const Comp_Edit_Form_Digital_New=(props)=>{
    let appUrlMedPath=getWaUrlPath();
    //alert(appUrlMedPath);

    const [members, setMembers] = useState([{}]);

  const doAddNewField=()=>{
    btnSetColorSerlized_CBack(this,"frmAddReqNewField","admNewFieldProcessForm",function(data,msg){
      if(data==="001"){
        alert(msg);
        window.location.reload();
      }else{
        alert(msg);
      }
    })
  }
  
  const doProcessForm=()=>{
    //alert("i min click");
    btnSetColorSerlized_CBack(this,"frmProcessForm","admDoProcessForm",function(data,msg){
        if(data==="001"){
          alert(msg);
          window.location.reload();
        }else{
          alert(msg);
        }
      })
  }

    const addRequestForm=()=>{
      //alert("i min click");
      btnSetColorDirect_CBack(this,"frmEditNewRequestDigital","editMultiReqForm",function(data,msg){
          if(data==="001"){
            alert(msg);
            window.location.reload();
          }else{
            alert(msg);
          }
        })
    }

    useEffect(()=>{
      // alert(JSON.stringify(props.profileData));
      //alert(JSON.stringify(props.formFields));

      if (props.profileData?.form_request) {
        //alert("i m in request");
        try {
          const parsed = JSON.parse(props.profileData.form_request);
          //alert(parsed);
          if (Array.isArray(parsed)) {
            setMembers(parsed); // load all members
          }
        } catch (e) {
          console.log("Invalid JSON");
        }
      }

      FileUploaderV1(this,function(data,msg){
       //alert("i m done");
      });
    },[props.profileData])
    return(<div className="modal fade bd-example-modal-xl" id="divEditFromDigitalSevaNew" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    
        <div className="modal-dialog modal-xl" role="document">
            <div className="modal-content">
                <div className="modal-header bg-primary">
                    <h4>{props.profileData.category_name}</h4>
                    <button type="button" className="close" data-bs-dismiss="modal" data-dismiss="modal" aria-label="Close"><span
                            aria-hidden="true">x</span></button>
                </div>
                {props.compUser.length>0 && members.length>0?<>
                <div className="modal-body" style={{"justify-content":"center",
    "align-items": "center"}}>


              <div class="row">
        <div class="col-md-8">
      <div id="respDigiSeva" name="respDigiSeva"></div>
                <div id="shiiping_add" style={{"width":"100%","margin":"auto"}}>
                               
                               {/* <h3>{props.formFields[0]["category_name"]}</h3> */}
                               <form id="frmEditNewRequestDigital" name="frmEditNewRequestDigital">
                               
                               <input type='hidden' name="m_type" id="m_type" value={"editMultiReqForm"} />
                               <input type='hidden' name="m_type" id="m_type" value={"editMultiReqForm"} />
                               <input type='hidden' name="res_func" id="res_func" value={"resnuse"}/>
                               <input type="hidden" name="ref_form_category" id="ref_form_category" value={btoa(props.profileData["category_master_id"])} />
                               <input  type='hidden'  name="loc_token" id="loc_token" value={props.compUser[0].id}/>
                               <input type='hidden' name="member_request_id" id="member_request_id" value={btoa(props.profileData["id"])}/>
                               
                            <input type="hidden" name="lsVideo" id="lsVideo"/>
                            <input type="hidden" name="lsPdf" id="lsPdf"/>
                               <div class="digital-seva-point-new-form">
         
      

        
          <div class="progress-strip mb-4">
            <div class="p-step active">
              <div class="p-num">1</div>
              <div class="p-label">{members[0]["category_name"]}</div>
            </div>
           
          </div>

          

         
            <div class="section-card">
                <div class="sh-line"></div>
              
              
                

                {members.map((item, index) => (
        <Multi_Member_Edit_Form
          key={index}
          index={index}
          formFields={members[index]}
          onRemove={() => {
            const updated = [...members];
            updated.splice(index, 1);
            setMembers(updated);
          }}
        />
      ))}
              
                  
                
              

              <div class="fields-body">
                {/* {members.length>0 && props.formFields.length>0?
              <button
        type="button"
        className="btn btn-submit btn-danger mt-3"
        onClick={() => setMembers([...members, [...props.formFields]])}
      >
        + Add New Form
      </button>:''} */}
              </div>
            
              <div class="fields-body">
              
                <div class="form-group">
                  <div class="col-12">
                  <label class="flabel">Feedback </label>
                  <textarea class="f-input f-textarea" rows="3" placeholder="Enter form requirements here"></textarea>
                </div>
                </div>
              </div>
            </div>

        
            <div class="submit-strip">
              {/* <button type="button" onClick={()=>addRequestForm()} class="btn-submit _btnSetColor11">Submit Application</button>
              <button type="reset" class="btn-reset">Reset</button> */}
            </div>

          
        </div>

        

      
                               </form>
                               </div>
      
      
      </div>


      {/* new col side */}
      <div class="digital-seva-point-new-form col-md-4 sidebar">
      <div class="section-card fields-body member-block11 border11 p-3 mb-3 d-flex flex-column flex-md-row">
                <div class="modal-image-section col-md-12">
                  <div class="profile-image-container">
                    
                    <div class="verified-tickmark">Verified</div>
                  </div>
                  <div class="basic-details">
                    <p><strong>Company/Retails:</strong> {props.profileData?.company_name}</p>
                    <p><strong>Contact No:</strong> {props.profileData?.contact_no}</p>
                    
                  
                  </div>
                  <div class="basic-details">
                    <p><strong>Request Id:</strong> {props.profileData?.id}</p>
                    <p><strong>Request Date:</strong> {props.profileData?.request_date}</p>
                    
                  
                  </div>
                  <form class="digital-seva-point-new-form" id="frmProcessForm" name="frmProcessForm">
                        <input type='hidden' name="m_type" id="m_type" value={"admDoProcessForm"} />
                               <input type='hidden' name="m_type" id="m_type" value={"admDoProcessForm"} />
                               <input type='hidden' name="res_func" id="res_func" value={"resnuse"}/>
                               <input type='hidden' name="loc_token" id="loc_token" value={btoa(props.profileData.account_info_id)}/>
                               <input type='hidden' name="ref_request_id" id="ref_request_id"  value={btoa(props.profileData?.id)}/>
                               <input type='hidden' name="lsProcFiles" id="lsProcFiles"/>
                               <input type='hidden' name="lsReceiptRelease" id="lsReceiptRelease"/>
                               {/* <input type="hidden" name="ref_form_category" id="ref_form_category" value={btoa(props.formFields[0]["category_master_id"])} /> */}
                          
                        <div class="row">

                        <div className="col-12">
                                       <div className="billing-select mb-4">
                                          <label  class="flabel">Acknowledgment No.</label>
                                          <input className="form-control f-input required" id={"ack_no"} name={"ack_no"} type="text"
                                          defaultValue={props.profileData?.ack_no}
                                          />
                                       </div>
                                   </div>

                                   <div className="col-12">
                                       <div className="billing-select mb-4">
                                           <label  class="flabel">Process Status</label>
                                           <select className="form-control f-select select_target111 f-select required" id={"process_status"} name={"process_status"}>
                                               <option selected={props.profileData?.process_status===""} value={""}>Select</option>
                                               <option selected={props.profileData?.process_status==="Completed"} value={"Completed"}>Completed</option>
                                               <option selected={props.profileData?.process_status==="Under Process"} value={"Under Process"}>Under Process</option>
                                               <option selected={props.profileData?.process_status==="Under Progress"} value={"Under Progress"}>Under Progress</option>
                                               <option selected={props.profileData?.process_status==="Under Review"} value={"Under Review"}>Under Review</option>
                                               <option selected={props.profileData?.process_status==="Rejected"} value={"Rejected"}>Rejected</option>
                                               <option selected={props.profileData?.process_status==="Canceled"} value={"Cancelled"}>Cancelled</option>
                                             
                                           </select>
                                       </div>
                                   </div>

                                   <div className="col-lg-12 col-md-12">
                                    {props.profileData?.receipt_release!==""?<a target='blank' href={appUrlMedPath+props.profileData?.receipt_release}>View Uploded File</a>:''} 
                                          <div className="billing-info mb-4">
                                              {/* <label  class="flabel">{"Acknowledgement Receipt"}</label> */}
                                              <input type="file" name={"receipt_release"} id={"receipt_release"} ref_img="ImageThumbBackNew" thumbnail_div={"oth_img_div"} lsElement={"lsReceiptRelease"} thumbnail={"ReceiptRelease_processFmr"} accept="image/*,.pdf" capture="camera" size={1000000000} 
                        className='updImgThumb'
                        />
                                              <button class="file-zone _brFileThumb updthumb"   onClick={(e) => {
    e.preventDefault();
    e.stopPropagation();
  }} setTo={"receipt_release"}>
                       
                        <div class="file-icon">
                          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
                            <polyline points="17 8 12 3 7 8"/>
                            <line x1="12" y1="3" x2="12" y2="15"/>
                          </svg>
                        </div>
                        <div class="file-text">
                          <div class="ft-main">Acknowledgement Receipt</div>
                          <div class="ft-sub">PDF, JPG, PNG up to 5MB</div>
                        </div>
                      </button>

                                             
                                              
                                          </div>
                                          <div class={"row upload_image_css "+ "ReceiptRelease_processFmr"}></div>
                                      </div>

                                      {/* end of  acknowledgment receipt */}

                                   <div className="col-lg-12 col-md-12">
                                    {props.profileData?.doc_release!==""?<a target='blank' href={appUrlMedPath+props.profileData?.doc_release}>View Uploded File</a>:''} 
                                          <div className="billing-info mb-4">
                                              {/* <label  class="flabel">{"Acknowledgement Receipt"}</label> */}
                                              <input type="file" name={"upd_acknow_rec"} id={"upd_acknow_rec"} ref_img="ImageThumbBackNew" thumbnail_div={"oth_img_div"} lsElement={"lsProcFiles"} thumbnail={"imgLibThumb_processFmr"} accept="image/*,.pdf" capture="camera" size={1000000000} 
                        className='updImgThumb'
                        />
                                              <button class="file-zone _brFileThumb updthumb"   onClick={(e) => {
    e.preventDefault();
    e.stopPropagation();
  }} setTo={"upd_acknow_rec"}>
                       
                        <div class="file-icon">
                          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
                            <polyline points="17 8 12 3 7 8"/>
                            <line x1="12" y1="3" x2="12" y2="15"/>
                          </svg>
                        </div>
                        <div class="file-text">
                          <div class="ft-main">Upload Certificate/Doc</div>
                          <div class="ft-sub">PDF, JPG, PNG up to 5MB</div>
                        </div>
                      </button>

                                             
                                              
                                          </div>
                                          <div class={"row upload_image_css "+ "imgLibThumb_processFmr"}></div>
                                      </div>

                        <div className="col-lg-12">
                                       <div className="billing-select mb-4">
                                           <label  class="flabel">Description (if Any)</label>
                                          <textarea defaultValue={props.profileData?.process_desc} class="form-control" id="process_desc" name="process_desc">

                                          </textarea>
                                       </div>
                                   </div>

                                   <div class="submit-strip">
              <button type="button" onClick={()=>doProcessForm()}  class="btn-submit _btnSetColor11">Submit Process</button>
              <button type="reset" class="btn-reset">Reset</button>
            </div>
                       
                        </div>
                        </form>
                </div>

               
                {/* <div class="gallery-container col-md-7">
                        <div class="gallery-title"><h5>Process Form</h5></div>
                        
                      </div> */}
              </div>


{/* section for extra document */}

<div class="section-card fields-body member-block11 border11 p-3 mb-3 d-flex flex-column flex-md-row">
                <div class="modal-image-section col-md-12">
                
                 
                  <div class="basic-details">
                    <p><h4>Extra Documents</h4></p>
                  
                  </div>
                  <form class="digital-seva-point-new-form" id="frmAddReqNewField" name="frmAddReqNewField">
                        <input type='hidden' name="m_type" id="m_type" value={"admNewFieldProcessForm"} />
                               <input type='hidden' name="m_type" id="m_type" value={"admNewFieldProcessForm"} />
                               <input type='hidden' name="res_func" id="res_func" value={"resnuse"}/>
                               <input type='hidden' name="loc_token" id="loc_token" value={btoa(props.profileData.account_info_id)}/>
                               <input type='hidden' name="ref_request_id" id="ref_request_id"  value={btoa(props.profileData?.id)}/>
                               
                               {/* <input type="hidden" name="ref_form_category" id="ref_form_category" value={btoa(props.formFields[0]["category_master_id"])} /> */}
                          
                        <div class="row">
                        <div className="col-12">
                                       <div className="billing-select mb-4">
                                          <label  class="flabel">Field Name.</label>
                                          <input className="form-control f-input required" id={"field_name"} name={"field_name"} type="text"/>
                                       </div>
                                   </div>

                                   <div className="col-12">
                                       <div className="billing-select mb-4">
                                           <label  class="flabel">Filed Type</label>
                                           <select className='form-control required' id="field_type" name="field_type">
                    <option value={"0"}>-Select-</option>
                    <option value={"date"}>Date</option>
                    <option value={"dropdown"}>Dropdown</option>
                    <option value={"file"}>File</option>
                    <option value={"number"}>Number</option>
                    <option value={"text"}>Text</option>
                </select>
                                       </div>
                                   </div>
                        <div className="col-lg-12">
                                       <div className="billing-select mb-4">
                                           <label  class="flabel">Dropdown Option(s) if Any (, comma separated):
</label>
                                          <textarea class="form-control" id="option_if_any" name="option_if_any">

                                          </textarea>
                                       </div>
                                   </div>

                                   <div class="col-md-12 form-group pl-2 pr-2 mb-4">
                <label class="float-left"><strong>Priority:</strong></label>
                <input name="priority" id="priority" type="number" class="form-control required" placeholder="Priority" required/>
            </div>

            <div class="col-md-12 form-group pl-2 pr-2 mb-4">
                <label class="float-left"><strong>Category Status:</strong></label>
                <select className='form-control required' id="status" name="status">
                    <option value={"Active"}>-Active-</option>
                </select>
            </div>

                                   <div class="submit-strip">
              <button type="button" onClick={()=>doAddNewField()}  class="btn-submit _btnSetColor11">Add New Filed</button>
              
            </div>
                       
                        </div>
                        </form>
                </div>

               
             
              </div>

{/* end of extra document */}



        </div>
      {/* end of new col */}

                               </div>
                </div></>:''}
            </div>
        </div>
        </div>)

}
export default Comp_Edit_Form_Digital_New;